import { PropsWithChildren } from 'react'
import { filterDOMProps } from '@react-aria/utils'
import styles from './Title.module.scss'
import { factory, Factory } from 'almanac-ui/factory'

type TitleProps = PropsWithChildren<{
  color?: string
}>

export type TitleFactory = Factory<{
  props: TitleProps
  ref: HTMLHeadingElement
  children: React.ReactNode
}>

export const Title = factory<TitleFactory>(({ children, color, ...otherProps }, ref) => {
  const domProps = filterDOMProps(otherProps)

  return (
    <h1 className={styles.root} {...domProps} ref={ref} style={{ color }}>
      {children}
    </h1>
  )
})
